var headerBeforePos = 0;//スクロールの値の比較用の設定

//スクロール途中でヘッダーが消え、上にスクロールすると復活する設定を関数にまとめる
function ScrollAnime() {
  var elemTop = 300;//#area-2の位置まできたら
  var scroll = $(window).scrollTop();
    //ヘッダーの出し入れをする
    if(scroll == headerBeforePos) {
    //IE11対策で処理を入れない
    }else if(elemTop > scroll || 0 > scroll - headerBeforePos){
    //ヘッダーが上から出現する
      $('.header__wrapper2').removeClass('hide'); //#headerにUpMoveというクラス名を除き
      $('.header__main-nav').slideDown(0);
    }else {
    //ヘッダーが上に消える
      $('.header__wrapper2').addClass('hide');//#headerにDownMoveというクラス名を除き
      $('.header__main-nav').slideUp(0);
    }    
    headerBeforePos = scroll;//現在のスクロール値を比較用のheaderBeforePosに格納
}
// Throttle function for scroll events
function throttleHeader(func, limit) {
  let inThrottle;
  return function() {
    const args = arguments;
    const context = this;
    if (!inThrottle) {
      func.apply(context, args);
      inThrottle = true;
      setTimeout(() => inThrottle = false, limit);
    }
  }
}

// Throttled scroll handler
const throttledHeaderScroll = throttleHeader(function() {
  ScrollAnime();
  filterFixed();
}, 100);

// 画面をスクロールをしたら動かしたい場合の記述
$(window).scroll(throttledHeaderScroll);

// ページが読み込まれたらすぐに動かしたい場合の記述
$(window).on('load', function () {
  ScrollAnime();//スクロール途中でヘッダーが消え、上にスクロールすると復活する関数を呼ぶ
  filterFixed();
});


function filterFixed(){
  var headerHeight = $('header').height();
    $('.collection_filter_bar').css('top',headerHeight+'px');
};
